const my_profile = {
  viewMyClubSeacretProfile: "View My ClubSeacret Profile",
  viewMoreDetails: "View More Details",
  verifiedEmail: "Verified Email",
  unverifiedEmail: "Unverified Email",
  balance: "Balance",
  pointsIn: "Points In",
  pointsOut: "Points Out",
  topUp: "Top Up",
  pointsHistoryTable: "Points History Table",
};

export default my_profile;
